import React from 'react'
import PropTypes from 'prop-types'

import DataTable from 'components/organisms/DataTable'
import PaginationControl from 'components/organisms/PaginationControl'

import { userGroupColumns } from '.'

const UserGroups = ({
  groups,
  filters,
  tableLoading,
  onPageChange,
  onTableSortClick,
  onGroupItemSelect,
}) => (
  <React.Fragment>
    <DataTable
      dataProvider={groups}
      columns={userGroupColumns}
      tableLoading={tableLoading}
      onSortClick={onTableSortClick}
      onItemSelect={onGroupItemSelect}
      emptyStateTitle="This user has no groups"
      emptyStateDescription="Any groups you add this user to will appear here"
    />
    <PaginationControl pagination={filters.pagination} onPageChange={onPageChange} />
  </React.Fragment>
)

UserGroups.propTypes = {
  groups: PropTypes.object,
  filters: PropTypes.object,
  tableLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onGroupItemSelect: PropTypes.func,
}

export default UserGroups



// WEBPACK FOOTER //
// ./src/components/organisms/UserGroups/UserGroups.js